<template>
    <section>
        <div class="about-footer-flex-container">
            <div class="about-footer-content">
                <p>
                    <span>{{ $t('aboutPage.waitingQuestion') }}</span>
                    <span class="font-bold db-s dib-m">{{ $t('aboutPage.joinToday') }}</span>
                </p>
                <router-link aria-label="Join YouGov.chat" to="/" class="flex">
                    <AppButton class="about-footer-link mx-auto mt-2" size="large" :label="$t('aboutPage.joinLink')"
                /></router-link>
            </div>
        </div>
    </section>
</template>

<script>
import AppButton from '@/components/AppButton';
import { ButtonVariant } from '@/enums/';

export default {
    name: 'AboutFooter',
    components: {
        AppButton,
    },
    created() {
        this.$options.ButtonVariant = ButtonVariant;
    },
};
</script>

<style scoped lang="scss">
.about-footer-flex-container {
    display: flex;
    background-color: $about-section-background;
}
.about-footer-content {
    margin: 4rem auto 5rem;
    text-align: center;
    font-size: $large-font-size;
    line-height: 1.7;
    color: $about-section-text;
}
.about-footer-link {
    min-width: 25rem;
}
</style>
